
;
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"lightbox","lightbox":"no"};
                    const ID = 'ecom-3l32v2tlani';
                    document.querySelectorAll('.ecom-3l32v2tlani').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            